import { Pipe, PipeTransform } from '@angular/core';

export interface Search {
  value?: string;
  item?: string;
  noValidateActive?: boolean;
}

@Pipe({
  name: 'filterList',
  standalone: false
})
export class FilterListPipe implements PipeTransform {

  transform<T = any>(list: T[] | null, search?: Search): T[] | null {
    if (!list || !search?.value) {
      return list;
    }

    const term = this.normalize(search.value).toLowerCase();
    const field = search.item as keyof T | undefined;

    return list.filter((item: any) => {

      let text = '';

      if (field && item?.[field] != null) {

        const val = item[field];

        text = typeof val === 'object'
          ? String(val?.[field as any] ?? '')
          : String(val);

      }

      const matches = this.normalize(text).toLowerCase().includes(term);
      const isActive = (item?.active ?? true) || search.noValidateActive;
      return matches && isActive;

    });

  }

  private normalize(text?: string): string {
    return text
      ? text.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      : '';
  }

}